module.exports = __webpack_public_path__ + "img/img26.a5ad57e4.svg";